/** Service Desk console, ticket detail: equipment, contract, visits, RMAs, child tickets and resolving over open children (SD-S3-10, TKT-143). */
export const serviceTicketAfterSales = {
  equipment: {
    title: "Equipment",
    none: "No equipment is named on this ticket.",
    error: "The equipment couldn't load.",
    more: "{{count}} more not shown.",
  },
  contract: {
    title: "Contract",
    noneChip: "No contract",
    none: "No active contract covers this ticket: the work is chargeable unless the warranty applies.",
    error: "The contract cover couldn't load.",
    viaAsset: "Covers the equipment on this ticket.",
    viaOrganisation: "Covers the whole organisation.",
  },
  visits: {
    title: "Field visits",
    none: "No visit is planned for this ticket.",
    error: "The visits couldn't load.",
    schedule: "Schedule a visit",
  },
  rmas: {
    title: "Returns (RMA)",
    none: "No return, repair or replacement started.",
    error: "The returns couldn't load.",
    create: "Create RMA",
  },
  children: {
    title: "Child tickets",
    none: "No child tickets. Split the work into pieces when it takes more than one.",
    isChild: "This ticket is part of a bigger one.",
    error: "The child tickets couldn't load.",
    progress: "{{done}} of {{total}} resolved",
    hidden: "{{count}} more you cannot open are counted in the progress.",
    limit: "A ticket takes at most {{max}} child tickets.",
    create: "Create child ticket",
    createTitle: "Create child ticket",
    createBody: "A new ticket under {{number}}.",
    createSubmit: "Create child ticket",
    created: "Child ticket {{number}} created",
    inherits: "It keeps the organisation, site, requester and equipment of the parent ({{organisation}}).",
    noOrganisation: "no organisation",
    titleLabel: "Title",
    descriptionLabel: "What needs doing",
    problemTitle: "Give a title of at least {{min}} characters.",
    notify: "Tell the client about this ticket",
    notifyHint: "A child is usually internal work, so the client is not told unless you ask.",
  },
  forceResolve: {
    open_one: "{{count}} child ticket is still open.",
    open_other: "{{count}} child tickets are still open.",
    blocked: "Child tickets are still open. Close them first; only someone who manages tickets can resolve over them.",
    reason: "Why you resolve anyway",
    hint: "At least {{min}} characters. It is kept on the ticket and in the audit trail.",
    reasonRequired: "Give a reason of at least {{min}} characters.",
    submit: "Resolve anyway",
  },
} as const;
